

const data = {
  key: 'summer-schedule-template',
  name: 'Summer Schedule Template',
};
export default data;
